import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
var Hero = /*#__PURE__*/ function (_Component) {
    _inheritsLoose(Hero, _Component);
    function Hero() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = Hero.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                backgroundImage: this.props.background ? "url('" + this.props.background + "')" : '',
                backgroundSize: 'cover',
                backgroundColor: this.props.backgroundColor || "#ffffff",
                backgroundRepeat: 'no-repeat',
                color: this.props.color || "#000000"
            },
            className: "px-8 pb-24"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "container mx-auto"
        }, this.props.h1 ? /*#__PURE__*/ React.createElement("h1", {
            className: "text-5xl font-ibm font-bold py-10"
        }, this.props.title) : /*#__PURE__*/ React.createElement("h2", {
            className: "text-4xl font-ibm font-bold py-10"
        }, this.props.title), this.props.secondaryTitle ? /*#__PURE__*/ React.createElement("h2", {
            className: "text-4xl font-ibm font-bold py-5"
        }, this.props.secondaryTitle) : null, /*#__PURE__*/ React.createElement("p", {
            className: "pl-4"
        }, this.props.children)));
    };
    return Hero;
}(Component);
export { Hero as default };
